import React, { useState } from "react";

interface HomeProps{
    size?: number|string;
    className?:string;
    onClick?: () => void;
    color?: string;
}
const Home: React.FC<HomeProps> = ({
    size = 20,
    className,
    onClick,
    color,

}) => {
    const [isHovered,setIsHovered] = useState<boolean>(false);
     const style = size ? { width: size, height: size } : undefined;
     return(
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <g clip-path="url(#clip0_1550_728)">
            <path d="M8 16.3302H16M11.0177 2.0942L4.23539 7.36933C3.78202 7.72195 3.55534 7.89826 3.39203 8.11906C3.24737 8.31464 3.1396 8.53498 3.07403 8.76925C3 9.03372 3 9.3209 3 9.89525V17.1302C3 18.2503 3 18.8103 3.21799 19.2382C3.40973 19.6145 3.71569 19.9205 4.09202 20.1122C4.51984 20.3302 5.07989 20.3302 6.2 20.3302H17.8C18.9201 20.3302 19.4802 20.3302 19.908 20.1122C20.2843 19.9205 20.5903 19.6145 20.782 19.2382C21 18.8103 21 18.2503 21 17.1302V9.89525C21 9.3209 21 9.03372 20.926 8.76925C20.8604 8.53498 20.7526 8.31464 20.608 8.11906C20.4447 7.89826 20.218 7.72195 19.7646 7.36933L12.9823 2.0942C12.631 1.82095 12.4553 1.68432 12.2613 1.6318C12.0902 1.58546 11.9098 1.58546 11.7387 1.6318C11.5447 1.68432 11.369 1.82095 11.0177 2.0942Z" 
              stroke={isHovered ? "#0094BD" : color}
                strokeWidth='1.67'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id="clip0_1550_728">
            <rect width="24" height="24" fill="white" transform="translate(0 0.3302)"/>
            </clipPath>
        </defs>
    </svg>
     );
};

export default Home;